import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var CustomLoader = function(props) {
    var loading = props.i18n.common.loading;
    var numberOfLines = props.numberOfLines ? props.numberOfLines : 5;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            numberOfLines >= 1 && /*#__PURE__*/ _jsx("img", {
                className: "loading-bar",
                src: "/assets/media/bar_1.gif",
                alt: loading
            }),
            numberOfLines >= 2 && /*#__PURE__*/ _jsx("img", {
                className: "loading-bar",
                src: "/assets/media/bar_2.gif",
                alt: loading
            }),
            numberOfLines >= 3 && /*#__PURE__*/ _jsx("img", {
                className: "loading-bar",
                src: "/assets/media/bar_3.gif",
                alt: loading
            }),
            numberOfLines >= 4 && /*#__PURE__*/ _jsx("img", {
                className: "loading-bar",
                src: "/assets/media/bar_4.gif",
                alt: loading
            }),
            numberOfLines >= 5 && /*#__PURE__*/ _jsx("img", {
                className: "loading-bar",
                src: "/assets/media/bar_5.gif",
                alt: loading
            })
        ]
    });
};
export default CustomLoader;
